import { loadInputImask } from './loadInputImask'
import IMask from 'imask'
/**
 *
 * @param {HTMLInputElement} input
 */
export function loadBirthdateIMask(input) {
  loadInputImask(input, {
    mask: 'MM/DD/YYYY',
    lazy: true,
    blocks: {
      MM: {
        // @ts-ignore
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
      },
      DD: {
        // @ts-ignore
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
      },
      YYYY: {
        // @ts-ignore
        mask: IMask.MaskedRange,
        from: 1900,
        to: new Date().getFullYear(),
      },
    },
  })
}
